import account from './account';
import setting from './setting';
import design from './design';
import page from './page';
import designCategory from './designCategory';
export default {
  account: account,
  setting: setting,
  page: page,
  design: design,
  designCategory: designCategory
};